import { stringify } from 'query-string';

import { ILinkfireTableArgs } from 'helpers/interceptors/linkfireTableInterceptor';

function getLinkfireTableUrl(args: ILinkfireTableArgs): string {
  const { entityType, entityIds, tableType } = args;

  const params = stringify({
    limit: 999,
  });

  return `/api/marketing/${tableType}/${entityType}/${entityIds}?${params}`;
}

export default getLinkfireTableUrl;
